export const REPORT_TEXTS = {
  default: {
    ci: {
      title: "Your TeamLytica Cohesion Index",
      subtitle: [
        "Welcome to your TeamLytica dashboard. It’s packed full of really useful information generated through the responses of your team. Click any of the bars below to explore your category scores, disparity and question scores.",
        "Scroll down beneath the question scores to see the system-generated commentary and actions. Each tab give you access to further detailed insights into how the team feel they work together.",
      ],
    },
    si: {
      title: "Your TeamLytica Stress Index",
      subtitle: [
        "Stress is a critical driver of how teams and individuals work together. This section provides you with a stress indicator for your team and is based on their responses within the questionnaire.",
        "The commentary bellow will give you an indication of where focus should be given to help the team manage its stress levels.",
      ],
    },
    mi: {
      title: "Your TeamLytica Morale Index",
      subtitle: [
        "This page gives you a Morale indicator for your team which has been graded as either negative, neutral or positive. Use the details and commentary below to work out a plan on how to support your team and boost its morale to boost team cohesion and performance.",
      ],
    },
  },
  benchmark: {
    ci: {
      title: "Your TeamLytica Cohesion Index",
      subtitle: [
        "Welcome to your TeamLytica benchmark dashboard. It’s packed full of really useful information generated through the responses of your team across two reports. Click any of the bars below to explore and compare your category, disparity and question scores for each report.",
        "You’ll see dated scores that either show improvements or, where elements have slipped back. Scroll down beneath the question scores to see the system-generated commentary and actions which will relate to the latest report. ",
      ],
    },
    si: {
      title: "Your TeamLytica Stress Index",
      subtitle: [
        "Stress is a critical driver of how teams and individuals work together and the performance they are able to deliver over a sustained period of time. It’s also important to the wellbeing and health of those within the team.",
        "The left hand curve shows data from your first selected report and the second date range is on the right. Ideally, you want both to be within the green zone. Use the indicators to take positive action to ensure the team works at its optimal performance levels.",
      ],
    },
    mi: {
      title: "Your TeamLytica Morale Index",
      subtitle: [
        "This page gives you a Morale benchmark indicator for your team which has been graded as either negative, neutral or positive. The first date range selected is shown on the left hand side and the second, on the right.",
        "Ideally, morale should be scoring positive in both sections demonstrating that team members enjoy and are motivated by what they do.",
        "Use the details and commentary below to work out a plan on how to support your team and boost its morale to improve or maintain team cohesion and performance.",
      ],
    },
    top_10: {
      title: "Your Top 10 Scoring Questions",
      subtitle: [
        "This section gives you an overview of the top ten scoring questions for your team across two date ranges of reporting. Use the date range toggle button top right to select which reports you wish to compare and contrast.",
        "These scores show what the team believes it does well together. These questions can be used to praise the team as they are seen as an area of strength.",
      ],
    },
    urgent_actions: {
      title: "Urgent Actions",
      subtitle: [
        "Your urgent actions include two areas across two date ranges. The first are the team’s three lowest scoring questions which will give you a strong indication of where the team feels it is at its weakest.",
        "The second three questions scores are those with the great range of responses – or disparity. This shows you where the team are working and thinking very differently to each other – and a sign of lack of cohesion in these areas.",
        "Use the date range toggle button top right to select which reports you’d like to compare and contrast.",
      ],
    },
    comments: {
      title: "Comments",
      subtitle: [
        "Within the questionnaire are three questions that ask your stakeholders to comment on your team. We ask them what they feel the team does well, what it can improve upon and to suggest three ‘quick wins’ that the team could implement to improve team working or performance.",
        "The comments are written verbatim as the platform does not edit or amend what’s been written in any way. It may include errors, spelling mistakes and very occasionally, inappropriate language.",
        "Use the date range toggle button top right to select which reports you’d like to compare and contrast.",
      ],
    },
  },
  team360: {
    ci: {
      title: "Your Team360 Cohesion Index",
      subtitle: [
        "Welcome to your TeamLytica Team360 report. This report is shown is isolation to your other reports to give you an overview of what your stakeholders think of how your team operates. At any time you can use the benchmarking function to compare these results with any of your own team cohesion reports.",
      ],
    },
    si: {
      title: "Your Team360 Stress Indicator",
      subtitle: [
        "Stress is a critical driver of how teams and individuals work together. By measuring and understanding stress you can adjust your approach, delegation and working practices to get the best from your team. Managing stress to the right level will ensure you get optimum performance from your team.",
      ],
    },
    mi: {
      title: "Your Team360 Morale Indicator",
      subtitle: [
        "Team morale means that that there is an abundance of drive, self-esteem, assurance and a generally positive outlook in the team. This will be enhanced through self-belief and positive humour that enables the team to enjoy what they do and be confident in their abilities.",
        "When a team has good morale, there will be an excitement and enthusiasm for their work and performance should be high.",
      ],
    },
  },
  notfullReport: {
    ci: {
      title: "Your Free TeamLytica Summary Report",
      subtitle: [
        "Welcome to your TeamLytica dashboard. This is the free version of the platform so contains only your Cohesion score and the nine category scores shown below. If you require a more detailed report, then click on any of the upgrade buttons or pages for full access. You can download a copy of the summary report using the PDF button on the top right of this page.",
      ],
    },
    si: {
      title: "Your Free TeamLytica Summary Report",
      subtitle: [
        "Welcome to your TeamLytica dashboard. This is the free version of the platform so contains only your Cohesion score and the nine category scores shown below. If you require a more detailed report, then click on any of the upgrade buttons or pages for full access.",
        "You can download a copy of the summary report using the PDF button on the top right of this page.",
      ],
    },
    mi: {
      title: "Your Free TeamLytica Summary Report",
      subtitle: [
        "Welcome to your TeamLytica dashboard. This is the free version of the platform so contains only your Cohesion score and the nine category scores shown below. If you require a more detailed report, then click on any of the upgrade buttons or pages for full access.",
        "You can download a copy of the summary report using the PDF button on the top right of this page.",
      ],
    },
  },
};
